export enum ResellerSiderItem {
	ONBOARDING = 'Onboarding',
	MY_RECEPTIONISTS = 'My Receptionists',
	TRIAL_RECEPTIONIST = 'Trial Receptionist',
	PLANS = 'Plans',
	PLAN_CREATION = 'Plan Creation',
	PLAN_VIEW = 'Plan Management',
	EMBED = 'Embed',
	BRANDING_CONFIG = 'Branding Configurations',
	CUSTOM_DOMAIN = 'Website Integration',
	BRANDING = 'Branding',
	TUTORIALS = 'Tutorials',
	SUBSCRIPTION = 'Subscription',
	PHONE_NUMBERS = 'Phone Numbers',
	EMAIL_CONFIG = 'Email Configuration',
	IMPORT_NUMBER = 'Import Twilio',
	ACADEMY = 'Academy',
	WEBHOOKS = 'Webhooks',
	OUTBOUND_ROOT = 'Outbound',
	OUTBOUND_MY_CAMPAIGNS = 'My Campaigns',
	OUTBOUND_BYOT = 'BYOT',
	CONTACT_SUPPORT = 'Contact Support',
	INTERCOM_SUPPORT = 'Intercom Support',
	MANAGE_CREDITS = 'Manage Credits',
}
